module.exports = "/static/assets/0cc8cff23987f4d8d8813ec795205b6c.png";